import { render, staticRenderFns } from "./ReviewListDropdown.vue?vue&type=template&id=00549c66&scoped=true&v-if=reviewLists.length%3E0&"
import script from "./ReviewListDropdown.vue?vue&type=script&lang=js&"
export * from "./ReviewListDropdown.vue?vue&type=script&lang=js&"
import style0 from "./ReviewListDropdown.vue?vue&type=style&index=0&id=00549c66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00549c66",
  null
  
)

export default component.exports